export default __webpack_public_path__ + "6e176622554d25be20ad9abd9b52f8ec.png";